import { useEffect } from 'react';
import { AppState } from 'react-native';
import { envoyerFile } from '../services/collecte';

/**
 * Envoie la file d'événements du pilotage : au montage connecté, au retour au premier plan et au
 * passage en arrière-plan (au mieux : le système peut suspendre l'envoi, la file garde le lot).
 * N'attend rien et ne rend rien : la garde et la session sont relues par `envoyerFile`.
 */
export function useCollecteApp(connecte: boolean): void {
  useEffect(() => {
    if (!connecte) return;
    void envoyerFile();
    const sub = AppState.addEventListener('change', (etat) => {
      if (etat === 'active' || etat === 'background') void envoyerFile();
    });
    return () => sub.remove();
  }, [connecte]);
}
